var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    width: 19.08,
    height: 19.08,
    viewBox: "0 0 19.08 19.08",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9420",
    "data-name": "Group 9420",
    transform: "translate(4.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9419",
    "data-name": "Group 9419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    d: "M103.081,0a.681.681,0,0,0-.681.681V2.044h1.363V.681A.681.681,0,0,0,103.081,0Z",
    transform: "translate(-102.4)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9422",
    "data-name": "Group 9422",
    transform: "translate(13.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9421",
    "data-name": "Group 9421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M342.014,0a.681.681,0,0,0-.681.681V2.044H342.7V.681A.681.681,0,0,0,342.014,0Z",
    transform: "translate(-341.333)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9424",
    "data-name": "Group 9424",
    transform: "translate(0 2.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9423",
    "data-name": "Group 9423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M17.036,51.2H14.991v2.726a.681.681,0,1,1-1.363,0V51.2H5.451v2.726a.681.681,0,1,1-1.363,0V51.2H2.044A2.044,2.044,0,0,0,0,53.244V66.191a2.044,2.044,0,0,0,2.044,2.044H17.036a2.044,2.044,0,0,0,2.044-2.044V53.244A2.044,2.044,0,0,0,17.036,51.2Zm.681,14.991a.681.681,0,0,1-.681.681H2.044a.681.681,0,0,1-.681-.681V57.333H17.717Z",
    transform: "translate(0 -51.2)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9426",
    "data-name": "Group 9426",
    transform: "translate(3.407 9.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9425",
    "data-name": "Group 9425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    d: "M87.377,238.933H86.014a.681.681,0,1,0,0,1.363h1.363a.681.681,0,1,0,0-1.363Z",
    transform: "translate(-85.333 -238.933)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9428",
    "data-name": "Group 9428",
    transform: "translate(8.177 9.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9427",
    "data-name": "Group 9427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    d: "M206.844,238.933h-1.363a.681.681,0,0,0,0,1.363h1.363a.681.681,0,0,0,0-1.363Z",
    transform: "translate(-204.8 -238.933)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9430",
    "data-name": "Group 9430",
    transform: "translate(12.947 9.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9429",
    "data-name": "Group 9429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M326.311,238.933h-1.363a.681.681,0,1,0,0,1.363h1.363a.681.681,0,0,0,0-1.363Z",
    transform: "translate(-324.267 -238.933)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9432",
    "data-name": "Group 9432",
    transform: "translate(3.407 12.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9431",
    "data-name": "Group 9431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M87.377,307.2H86.014a.681.681,0,1,0,0,1.363h1.363a.681.681,0,1,0,0-1.363Z",
    transform: "translate(-85.333 -307.2)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9434",
    "data-name": "Group 9434",
    transform: "translate(8.177 12.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9433",
    "data-name": "Group 9433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    d: "M206.844,307.2h-1.363a.681.681,0,0,0,0,1.363h1.363a.681.681,0,0,0,0-1.363Z",
    transform: "translate(-204.8 -307.2)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9436",
    "data-name": "Group 9436",
    transform: "translate(12.947 12.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9435",
    "data-name": "Group 9435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    d: "M326.311,307.2h-1.363a.681.681,0,1,0,0,1.363h1.363a.681.681,0,0,0,0-1.363Z",
    transform: "translate(-324.267 -307.2)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9438",
    "data-name": "Group 9438",
    transform: "translate(3.407 14.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9437",
    "data-name": "Group 9437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    d: "M87.377,375.467H86.014a.681.681,0,1,0,0,1.363h1.363a.681.681,0,1,0,0-1.363Z",
    transform: "translate(-85.333 -375.467)",
    fill: "#fff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9440",
    "data-name": "Group 9440",
    transform: "translate(8.177 14.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9439",
    "data-name": "Group 9439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    d: "M206.844,375.467h-1.363a.681.681,0,0,0,0,1.363h1.363a.681.681,0,0,0,0-1.363Z",
    transform: "translate(-204.8 -375.467)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9442",
    "data-name": "Group 9442",
    transform: "translate(12.947 14.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9441",
    "data-name": "Group 9441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    d: "M326.311,375.467h-1.363a.681.681,0,1,0,0,1.363h1.363a.681.681,0,0,0,0-1.363Z",
    transform: "translate(-324.267 -375.467)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.f719b7b6.svg";
export { ForwardRef as ReactComponent };